import * as C from '../constants';
import BookingService from '../../../services/booking-service';
import TwentyService from '../../../services/twenty-service';

export default {

  /**
   * @param commit
   */
  resetState({ commit }) {
    commit(C.BOOKING_RESET_STATE);
  },

  /**
   * @param commit
   * @param bookingId
   * @returns {Promise<void>|Promise<T>}
   */
  bookingWithCustomerAndStaysByBookingIdLoad({ commit }, bookingId) {
    commit(C.BOOKING_BY_ID_LOAD_PENDING);

    return BookingService.getBookingWithCustomerAndStaysByBookingId(bookingId)
      .then((res) => {
        commit(C.BOOKING_BY_ID_LOAD_SUCCESS, res.data);
      })
      .catch((error) => {
        commit(C.BOOKING_BY_ID_LOAD_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param bookingStayIds
   * @param payload
   * @returns {Promise<T>}
   */
  bookingStayParticipantsByBookingStayIds({ commit }, bookingStayIds) {
    commit(C.BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_PENDING);

    return BookingService.getBookingStayParticipantsByStayIds(bookingStayIds)
      .then((res) => {
        commit(C.BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_SUCCESS, res.data);
      })
      .catch((error) => {
        commit(C.BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T>}
   */
  bookingStayAreaLoad({ commit }, payload) {
    commit(C.BOOKING_STAY_AREA_PENDING);
    return TwentyService.getArea(payload).then((res) => {
      commit(C.BOOKING_STAY_AREA_SUCCESS, res.data);
    }).catch(() => {
      commit(C.BOOKING_STAY_AREA_FAILURE);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/booking/actions.js